import React, { FC } from 'react';
import { Box, Dialog, Grid, Typography } from '@mui/material';
import { ItemType, UploadType } from 'api/Responses/BulkUploadResponses';
import Button from 'components/Button';
import { useLanguage } from 'context/AppContext';
import * as Styles from './IgnoreUploadModal.styles';

interface IgnoreUploadModalProps {
  open: boolean;
  close: () => void;
  draft: ItemType;
  uploadType: UploadType;
  handleIgnoreItem: Function;
}

export type ModalContentType = 'selectItem' | 'selectTray' | 'selectPart';

const IgnoreUploadModal: FC<IgnoreUploadModalProps> = ({ open, close, draft, handleIgnoreItem }) => {
  const [language] = useLanguage();
  const handleClose = (): void => {
    close();
  };

  const ignoreItem = (): void => {
    handleIgnoreItem(draft);
    close();
  };

  return (
    <Dialog open={open} maxWidth="xs" fullWidth onClose={handleClose}>
      <Styles.ModalContent>
        <Box sx={{ display: 'flex', justifyContent: 'between', verticalAlign: 'center', paddingBottom: '20px' }}>
          <Typography variant="h5">
            {language.DataUpload.ignoreUploadModal.ignoreUpload}
            <Typography variant="subtitle1" style={{ paddingTop: '10px' }}>
              {language.DataUpload.ignoreUploadModal.warning}
            </Typography>
          </Typography>
        </Box>
        <Grid container justifyContent="space-between">
          <Button onClick={() => handleClose()}>{language.DataUpload.ignoreUploadModal.cancel}</Button>
          <Button onClick={() => ignoreItem()}>{language.DataUpload.ignoreUploadModal.ignore}</Button>
        </Grid>
      </Styles.ModalContent>
    </Dialog>
  );
};

export default IgnoreUploadModal;
